import config from '../config';

export async function fetchSites(backendFetch, includeMutes = false) {
  const base = config.REACT_APP_HOST || window.location.origin;
  const url = new URL("/api/v2/sites", base);
  if (includeMutes !== undefined) {
    url.searchParams.append("include_mutes", includeMutes);
  }
  const response = await backendFetch(url.toString());
  const text = await response.text();
  return JSON.parse(text.replace(/\bNaN\b/g, "null"));
}

function resolveIncludeMutes(includeMutes) {
  if (includeMutes !== undefined) return includeMutes;

  if (typeof window !== "undefined") {
    const stateIncludeMutes = window.history?.state?.usr?.includeMutes;
    if (typeof stateIncludeMutes === "boolean") return stateIncludeMutes;
    if (typeof stateIncludeMutes === "string") return stateIncludeMutes !== "mutes";
  }

  return true;
}

export async function fetchSiteData(backendFetch, siteId, includeMutes) {
  const base = config.REACT_APP_HOST || window.location.origin;
  const url = new URL("/api/v2/sites/" + siteId, base);
  url.searchParams.append("include_mutes", resolveIncludeMutes(includeMutes));

  const response = await backendFetch(url.toString());
  const text = await response.text();
  if (!text) return null;
  return JSON.parse(text);
}

export async function replaceBox(backendFetch, siteId, boxId) {
  const formData = new FormData();
  formData.append("box_id", boxId);

  await backendFetch(config.REACT_APP_HOST + "/api/v2/sites/replace-smartbox/" + siteId, {
    method: "PUT",
    body: formData,
  });
}

export async function renameSite(backendFetch, siteId, siteName) {
  const formData = new FormData();
  formData.append("site_name", siteName);

  await backendFetch(config.REACT_APP_HOST + "/api/v2/sites/rename/" + siteId, {
    method: "PUT",
    body: formData,
  });
}

export async function addOwnership(backendFetch, siteId, partner_company_id) {
  const formData = new FormData();
  formData.append("partner_company_id", partner_company_id);

  await backendFetch(config.REACT_APP_HOST + "/api/v2/sites/add-ownership/" + siteId, {
    method: "PUT",
    body: formData,
  });
}

export async function updateFavourite(backendFetch, siteId) {
  const formData = new FormData();

  await backendFetch(config.REACT_APP_HOST + "/api/v2/sites/favourite/" + siteId, {
    method: "PUT",
    body: formData,
  });
}

export async function deactivateSite(backendFetch, siteId, username = "", reason = "") {
  const formData = new FormData();
  formData.append("username", username);
  formData.append("reason", reason);

  const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/sites/deactivate_site/" + siteId, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Deactivating site failed");
  }

  return response;
}

export async function fetchFavouriteSites(backendFetch, count) {
  const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/sites/favourite/?n=" + count);
  return await response.json();
}

export async function fetchSiteProduct(backendFetch, siteId) {
  const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/sites/product/" + siteId);
  const text = await response.text();
  if (!text) return null;
  return JSON.parse(text);
}

export async function fetchSiteMaximumProduction(backendFetch, siteId) {
  const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/sites/maximum-production/" + siteId);
  const text = await response.text();
  if (!text) return null;

  try {
    const parsed = JSON.parse(text);
    if (typeof parsed === "number") return parsed;
    if (parsed && typeof parsed.maximum_production === "number") return parsed.maximum_production;
    return null;
  } catch {
    const maybeNumber = Number(text);
    return Number.isFinite(maybeNumber) ? maybeNumber : null;
  }
}
